var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBackArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2654 19.2511C13.9026 19.8774 14.9786 19.4174 14.9662 18.524L14.9601 18.0814C14.9566 17.8265 14.8559 17.5827 14.6786 17.3996L8.4742 10.9921C8.08564 10.5908 7.44367 10.5857 7.0487 10.9806L6.67236 11.357C6.27944 11.7499 6.2822 12.3878 6.67851 12.7773L13.2654 19.2511Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7249 6.52722C14.9015 6.34136 15 6.09476 15 5.83837L15 5.41408C15 4.52318 13.9229 4.07701 13.2929 4.70698L6.66623 11.3336C6.2757 11.7242 6.2757 12.3573 6.66623 12.7479L7.04193 13.1236C7.43951 13.5211 8.08662 13.5129 8.47394 13.1053L14.7249 6.52722Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back-arrow.5dbab12a.svg";
export { ForwardRef as ReactComponent };